





































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/Clientes/FiltrosBusqueda.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { save_report } from '@/pantallas/Informes/partes/fetchSaveReport';
import { postReporteTime } from '@/pantallas/Informes/partes/postReporteTime';
import MensajeValidacionHRef from '@/pantallas/Informes/partes/MensajeValidacionHRef.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MensajeValidacion from '../../../reusable/Mantenedor/MensajeValidacion.vue';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef_DEPRECATED,
  creadoPorColumnDefs,
  modificadoPorColumnDefs,
  fechaCreacionColumnDefs,
  fechaModificacionColumnDefs,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { LoadingService } from '@/services/loadingService';
import HandleErrors from '@/config/handleErrors'; //
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import moment from 'moment';
import VerDetalleModal from '@/pantallas/Peajes/Tarifas/VerDetalleModal.vue';
import { fetchTelemetria } from '@/pantallas/Telemetria/fetchTelemetria';
@Component({
  components: {
    MantenedorGridSinCodigo,
    FiltrosBusqueda,
    VerDetalleModal,
    DatePicker,
    TimePicker,
    MensajeValidacion: MensajeValidacionHRef,
    FormFieldsContainer,
    AgGridVue,
  },
})
export default class ReporteTelemetria extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.TelemetriaDashboard;
  accionesTotales: PermisoAccion[] = [];
  requestsStart: number = 0;
  row: string = 'pdf';
  isFormValid: boolean = false;
  fechaDesde: any = moment(new Date()).add(-1, 'weeks');
  fechaHasta: any = moment();
  horaDesde: any = moment('00:00', 'HHmm');
  horaHasta: any = moment('23:59', 'HHmm');
  checkAllVehiculos: boolean = false;
  vehiculos: any = [];
  vehiculoSeleccionados: any = [];
  reportList: any[] = [];
  reportType: string = 'telemetria';
  showBtnCancelar: boolean = false;
  showValidacionReporteRestricciones: boolean = false;
  tituloValidacion: string = '';
  mensajeValidacion: string = '';
  mensajeValidacionBot: string = '';
  mensajeHRef: any = null;
  showValidacionReporteTime: boolean = false;
  dataInforme: any = [];

  async generarReporte() {
    var valid = await this.$validator.validateAll();
    if (!valid) {
      return;
    }

    // Mapear
    const vehiculosProcesados = this.vehiculoSeleccionados.map(
      (vehiculo: any) => {
        return vehiculo.cod_vehiculo; // Solo extraemos los IDs
      }
    );

    console.log('Vehículos seleccionados (IDs):', vehiculosProcesados);

    var nombreReporte = '';
    switch (this.reportType) {
      case 'telemetria':
        nombreReporte = 'Telemetría';
        break;
      case 'telemetria_fuga_combustible':
        nombreReporte = 'Telemetría Fuga Combustible';
        break;
      case 'telemetria_viajes_conductor':
        nombreReporte = 'Viajes por Conductor';
        break;
      default:
        nombreReporte = 'Telemetría Detalle Viaje';
        break;
    }

    this.dataInforme = {
      vehiculos: vehiculosProcesados, // Solo los IDs de los vehículos
      starting_date: this.fechaDesde.format('DD-MM-YYYY').toString(),
      starting_hour: this.horaDesde.format('HH:mm').toString(),
      ending_date: this.fechaHasta.format('DD-MM-YYYY').toString(),
      ending_hour: this.horaHasta.format('HH:mm').toString(),
      vehiculos_seleccionados: {
        vehiculos: [],
        flotas: [],
        etiquetas: [],
      },
      user: localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user')).id
        : '',
      client: localStorage.clienteDefecto,
      nombreReporte: nombreReporte,
      report_type: this.reportType,
      formato: this.row,
      date_created: moment()
        .utcOffset(0, true)
        .toISOString(),
      orientation: 'Portrait',
    };

    console.log('Payload que se enviará (dataInforme):', this.dataInforme);
    this.aceptaGeneraInforme(true);
  }

  aceptaGeneraInforme(val: any) {
    this.showBtnCancelar = false;
    this.showValidacionReporteRestricciones = false;
    if (val) {
      this.loadingService.showLoading();
      console.log(
        'Datos que se enviarán al servicio dataInforme:',
        this.dataInforme
      );
      const res = postReporteTime(this.dataInforme, this.row)
        .then(async (resMin: any) => {
          const response = save_report(this.dataInforme, this.row)
            .then(async (response: any) => {
              if ('id_reporte' in response.data) {
                this.tituloValidacion = 'Informe Creado';
                this.mensajeValidacion =
                  'El informe ID ' +
                  response.data.id_reporte +
                  ' se ha solicitado exitosamente.';
                this.mensajeValidacionBot =
                  'Estará disponible en unos segundos en Histórico Informes.';
                this.mensajeHRef = '/informe-generado';
                this.showValidacionReporteRestricciones = true;
              } else {
                this.tituloValidacion = 'Error Generar Informe';
                this.mensajeValidacion =
                  'Hubo un error a la hora de generar el informe';
                this.showValidacionReporteRestricciones = true;
              }
            })
            .catch(() => {
              this.tituloValidacion = 'Error Generar Informe';
              this.mensajeValidacion =
                'Hubo un error a la hora de generar el informe';
              this.showValidacionReporteRestricciones = true;
              this.loadingService.hideLoading();
            })
            .finally(() => {
              this.loadingService.hideLoading();
            });
        })
        .finally(() => {
          this.loadingService.hideLoading();
        });
    }
  }

  textoComprimido(item: any) {
    let retorno: string = '';
    if (item.length > 14) {
      retorno = item.substr(0, 30) + '...';
    } else {
      retorno = item;
    }
    return retorno;
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  selectAllVehiculo() {
    if (this.checkAllVehiculos === true) {
      // Asegurarse de que todos los vehículos son seleccionados correctamente
      this.vehiculoSeleccionados = this.vehiculos.map((x: any) => ({ ...x }));
    } else {
      this.vehiculoSeleccionados = [];
    }
    console.log(
      'Vehículos seleccionados (todos):',
      JSON.parse(JSON.stringify(this.vehiculoSeleccionados))
    );
  }

  mounted() {
    this.getVehiculos();
    this.getReportList();
  }

  getReportList() {
    this.loadingService.showLoading;
    fetchTelemetria({}, 'getReportList')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.data.length === 0) {
            // self.gridApi.setRowData([{}]);
            this.$snotify.success('Sin tipo de reportes');
            // params.successCallback([{}], 0);
            // self.gridApi.showNoRowsOverlay();
          } else {
            this.reportList = response.data.data;
            // params.successCallback(
            //   response.data.data,
            //   response.data.data.length
            // );
            // self.gridApi.hideOverlay();
          }
        } else {
          this.$snotify.error('Error al traer los tipos de reporte');
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  getRut(): any {
    let rut = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user').replace(/'/g, '"'))
          .rutClienteDefecto
      : '';
    return rut;
  }

  async getVehiculos() {
    const body: {} = {
      id_cliente: this.getClientID(),
      id_usuario: this.getUserID().toString(),
      clienteDefecto: this.getClientID(),
      rut: this.getRut(),
    };
    this.loadingService.showLoading;
    fetchTelemetria(body, 'getVehiculos')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.data.length === 0) {
            // self.gridApi.setRowData([{}]);
            this.$snotify.success('Sin Datos');
            // params.successCallback([{}], 0);
            // self.gridApi.showNoRowsOverlay();
          } else {
            this.vehiculos = response.data.data;
            // params.successCallback(
            //   response.data.data,
            //   response.data.data.length
            // );
            // self.gridApi.hideOverlay();
          }
        } else {
          this.$snotify.error('Error al traer los registros');
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  get fechaMaxima() {
    const fechaMax = moment().format('YYYY-MM-DD h:mm:ss a');
    return fechaMax;
  }
}
